'use client';

import { c as _c } from "react/compiler-runtime";
import { Heart, HeartSolid } from '@byway/icons';
import { useTranslations } from 'next-intl';
import { Button as RAC_Button } from 'react-aria-components';
import { trackEvent } from '~/utils';
import styles from './SaveButton.module.css';
import type { SaveButtonProps } from './SaveButton.types';
import { SaveTripDialog } from './SaveTripDialog';
import { SAVE_TRIP_TRACKING_ID, useSaveTrip } from './useSaveTrip';
export const SaveButton = t0 => {
  const $ = _c(28);
  const {
    tripId,
    startDate,
    endDate,
    iconOnly: t1,
    noUnderline: t2
  } = t0;
  const iconOnly = t1 === undefined ? false : t1;
  const noUnderline = t2 === undefined ? false : t2;
  const t = useTranslations("account");
  let t3;
  if ($[0] !== endDate || $[1] !== startDate || $[2] !== tripId) {
    t3 = {
      tripId,
      startDate,
      endDate
    };
    $[0] = endDate;
    $[1] = startDate;
    $[2] = tripId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    isLoggedIn,
    isTripSaved,
    isDialogOpen,
    setIsDialogOpen,
    toggleSave,
    goToLogin,
    goToAccount
  } = useSaveTrip(t3);
  let t4;
  if ($[4] !== isTripSaved || $[5] !== t) {
    t4 = isTripSaved ? t("saved") : t("save");
    $[4] = isTripSaved;
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const label = t4;
  let t5;
  if ($[7] !== toggleSave) {
    t5 = () => {
      trackEvent(SAVE_TRIP_TRACKING_ID, {
        event_category: "click",
        event_label: SAVE_TRIP_TRACKING_ID
      });
      toggleSave();
    };
    $[7] = toggleSave;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const handlePress = t5;
  const t6 = `${styles.saveButton}${noUnderline ? ` ${styles.noUnderline}` : ""}`;
  const t7 = iconOnly ? label : undefined;
  let t8;
  if ($[9] !== isTripSaved) {
    t8 = isTripSaved ? <HeartSolid decorative={true} size="large" /> : <Heart decorative={true} size="large" />;
    $[9] = isTripSaved;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = !iconOnly && label;
  let t10;
  if ($[11] !== handlePress || $[12] !== t6 || $[13] !== t7 || $[14] !== t8 || $[15] !== t9) {
    t10 = <RAC_Button onPress={handlePress} className={t6} aria-label={t7}>{t8}{t9}</RAC_Button>;
    $[11] = handlePress;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== setIsDialogOpen) {
    t11 = () => setIsDialogOpen(false);
    $[17] = setIsDialogOpen;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== goToAccount || $[20] !== goToLogin || $[21] !== isDialogOpen || $[22] !== isLoggedIn || $[23] !== t11) {
    t12 = <SaveTripDialog isLoggedIn={isLoggedIn} isOpen={isDialogOpen} onClose={t11} onLogin={goToLogin} onGoToAccount={goToAccount} />;
    $[19] = goToAccount;
    $[20] = goToLogin;
    $[21] = isDialogOpen;
    $[22] = isLoggedIn;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t10 || $[26] !== t12) {
    t13 = <>{t10}{t12}</>;
    $[25] = t10;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
};